import React, { Component } from 'react';
import { connect } from 'react-redux';
import NativeSelect from '@material-ui/core/NativeSelect';
import InsertModal from "./insert_modal";
import * as CashTeller from './Saga/CashTellers';

import Grid from "./Grid";
// import * as ContractSearch from '../ContractSearch/Saga/ContractSearch';
// import ContractSearchComponent from '../ContractSearch/Index';
import { Modal, ModalHeader, ModalFooter, ModalBody } from 'reactstrap';
// import Search from "./Search";
// import { customerList,  customerNewDispSet } from '../../Store/Customers';
// import * as MonthlyMoney from './Saga/MonthlyMoney';
import Draggable from 'react-draggable'; // The default
// import RoomDocComponent from '../Rooms/RoomDocComponent';
import RentMoney from '../RentMoney/Index';

import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
interface Props {
    shops: any,
    cash_tellers_contentslist: any,
    section_id: any,
    user_id: any,
    selectedDate: any,
    get_list: any,
    GetList: any
}



interface State {
    refresh: boolean,
    modalcontract: boolean,
}


class Cashteller extends Component<Props, State> {


    constructor(props: Readonly<Props>) {
        super(props);

        this.state = {
            refresh: false,
            modalcontract: false,

        }

        this.toggle = this.toggle.bind(this);
    }

    toggle() {


        if (this.props.section_id == 0) {
            alert("左上で部署を選択して下さい");
            return;
        }


        this.setState(prevState => ({
            modalcontract: !prevState.modalcontract,
        }));
        return;
    }




    componentWillMount() {

    }

    refresh() {
        this.setState(prevState => ({
            refresh: !prevState.refresh,
        }));

        console.log(this.state.refresh);

        return
    }


    render() {

        return (
            <div>
                <button style={{ fontSize: "18px" }} className="btn btn btn-info item-outer col-lg-12" onClick={this.toggle}>登録</button>
                <InsertModal
                    selectedDate={this.props.selectedDate}
                    GetList={this.props.GetList}
                    user_id={this.props.user_id}
                    modalcontract={this.state.modalcontract}
                    toggle={this.toggle}
                    cash_tellers_contentslist={this.props.cash_tellers_contentslist}
                    secion_id={this.props.section_id}
                />

            </div >
        );
    }
};


const mapStateToProps = (state: any) => {
    return {
        shops: state.masterReducer.shops,

    }
}
function mapDispatchToProps(dispatch: any) {
    return {
        get_list(state: any) {
            dispatch(CashTeller.get_cash_tellers_list(state))
        },
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(Cashteller);




